// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23zov","colBig":"styles_colBig__MTNij","colSmall":"styles_colSmall__JY4Qr"};